// Browser-only preferences. No clinical records or account data are changed.
export const guideSeen = key => localStorage.getItem(key) === 'true' || localStorage.getItem(`${key}:skipped`) === 'true';
export function saveGuideProgress(key, completed) {
  if (completed) {
    localStorage.setItem(key, 'true');
    localStorage.removeItem(`${key}:skipped`);
  } else {
    localStorage.setItem(`${key}:skipped`, 'true');
  }
}
